var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71875 13.1458L6.67829 12.5802L10.6381 12.0146L7.99089 9.3677C9.89841 7.06649 12.7779 5.60007 16.0006 5.60007C21.7443 5.60007 26.4003 10.2564 26.4003 16.0001C26.4003 21.7439 21.7443 26.3999 16.0006 26.3999C12.5281 26.3999 9.45363 24.6979 7.56474 22.0822L5.61601 23.4835C7.94065 26.7036 11.7255 28.7999 16.0006 28.7999C23.0699 28.7999 28.8003 23.0694 28.8003 16.0001C28.8003 8.93083 23.0702 3.1998 16.0008 3.1998C12.1155 3.1998 8.6352 4.93121 6.28798 7.66394L3.85017 5.22613L3.28432 9.18623L2.71875 13.1458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdraw);
export default __webpack_public_path__ + "static/media/icon_withdraw.fe3ad54cd2f35872090a28dc2716bab2.svg";
export { ForwardRef as ReactComponent };